import { useState, useEffect } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { ArrowRightCircle } from "react-bootstrap-icons"
import  imageHeader from "../assets/img/image_header.svg"
import { Link } from 'react-scroll';



export const Banner = ({ onLoad }) => {
    const [loopNumber, setLoopNum] = useState(0)
    const toRotate = ['Machine Learning Dev.', 'Full-Stack Dev.']
    const [isDeleting, setIsDeleting] = useState(false)
    const [text, setText] = useState('')
    const [index, setIndex] = useState(1);
    const [delta, setDelta] = useState(100 - Math.random() * 100)
    const period = 100

    useEffect(() => {
        let ticker = setInterval(() => {
            tick()
        }, delta)

        return () => {clearInterval(ticker)}

    },[text])




    const tick = () => {
        let i = loopNumber % toRotate.length
        let fullText = toRotate[i]
        let updateText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1)
        
        setText(updateText)

        if (!isDeleting && updateText === fullText) {
            setIsDeleting(true);
            setIndex(prevIndex => prevIndex - 1);
            setDelta(period);
          } else if (isDeleting && updateText === '') {
            setIsDeleting(false);
            setLoopNum(loopNumber + 1);
            setIndex(1);
            setDelta(100);
          } else {
            setIndex(prevIndex => prevIndex + 1);
          }
    }

    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7} >
                        <span className="tagline">Bienvenido a mi portfolio!</span>
                        <h1>{`Mi nombre es Orestes Olivera Marrero soy: `}</h1><h1><span className="wrap">{text}</span></h1>
                        <p>Soy Especialista en Métodos Cuantitativos para la Gestión y Análisis de Datos en Organizaciones de la Facultad de Ciencias Ecónomicas de la UBA. En la carrera de grado egresé de Lic. en Administración de la FCE UBA. Me gustan los desafios tecnológicos enfocados a las soluciones organizacionales. Tengo más de diez años de experiencia en programación enfocados a procesos.</p>
                        <Link to="contact" smooth={true} duration={500}>
                            <button>Contacto! <ArrowRightCircle size={25}></ArrowRightCircle></button>
                        </Link>
                    </Col>
                    <Col xs={12} md={6} xl={5} >
                        <img src={imageHeader} alt="Header Image" onLoad={onLoad}></img>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
